import Combos from "../assets/combo1.png";
import Fries from "../assets/french-fry.png";
import Pizza from "../assets/h1_pizza.png";
import Burger from "../assets/h1_burger-1.png";
import Chicken from "../assets/grilled-2.png";
import Combo2 from "../assets/combo1.png";
import Drinks from "../assets/category-7.png";

export const dummyData = [
  {
    _id: "6474a02181682b0f1bb181bf",
    dishes: [
      {
        id: "64663e8dfe072f0461924091",
        restaurantID: "64663d1afe072f046192402b",
        dishID: "64663e8dfe072f0461924091",
        extras: [
          {
            text: "frites ",
            extras_price: 2,
            _id: "64695500fc1951272c99ccf6",
            selected: true,
          },
        ],
        name: "Poulet Merguez",
        quantity: 4,
        price: 52,
        dishPrice: 13,
        dishImageUrl:
          "https://res.cloudinary.com/dhsywr3il/image/upload/v1684624592/clickSo/dishes/blgdmcxggjw9uh4bh64k.jpg",
        deliveryFee: 0,
        serviceFee: 1.5,
      },
    ],
    restaurant_name: "AlyaNeila",
    user: "63e63f44275a619b2f809983",
    restaurantId: "64663d1afe072f046192402b",
    status: "completed",
    orderNumber: 1688734691727,
    total: 53.5,
    mode_of_payment: "google_pay",
    deliveryAddress: "10 Rue Edouard Vaillant, Nord",
    service_fee: 0,
    discount_amount: 52,
    reviews: [],
    avgRating: 0,
    reviewed: false,
    createdAt: "2023-05-29T12:52:49.567Z",
    updatedAt: "2023-05-29T13:02:29.162Z",
    __v: 0,
    invoice_url:
      "http://res.cloudinary.com/dhsywr3il/image/upload/v1685364774/invoices/oao54az8r5kscvubpljp.pdf",
    estimated_delivery_time: "13:27",
    id: "6474a02181682b0f1bb181bf",
  },
  {
    _id: "64748b8181682b0f1bb18083",
    dishes: [
      {
        id: "64663f06fe072f0461924153",
        restaurantID: "64663d1afe072f046192402b",
        dishID: "64663f06fe072f0461924153",
        extras: [],
        name: "Burger ",
        quantity: 1,
        price: 11,
        dishPrice: 11,
        dishImageUrl:
          "https://res.cloudinary.com/dhsywr3il/image/upload/v1685358596/clickSo/dishes/butxhluorlaxvdrvzaoj.jpg",
        deliveryFee: 0,
        serviceFee: 1.5,
      },
    ],
    restaurant_name: "AlyaNeila",
    user: "63e63f44275a619b2f809983",
    restaurantId: "64663d1afe072f046192402b",
    status: "ongoing",
    orderNumber: 1688322155520,
    total: 12.5,
    mode_of_payment: "google_pay",
    deliveryAddress: "10 Rue Edouard Vaillant, Nord",
    service_fee: 0,
    discount_amount: 11,
    reviews: [],
    avgRating: 0,
    reviewed: false,
    createdAt: "2023-05-29T11:24:49.635Z",
    updatedAt: "2023-05-29T12:51:58.505Z",
    __v: 0,
    invoice_url:
      "http://res.cloudinary.com/dhsywr3il/image/upload/v1685359494/invoices/it0gv1alfhzrwkffal6f.pdf",
    estimated_delivery_time: "11:59",
    id: "64748b8181682b0f1bb18083",
  },
  {
    _id: "6474848881682b0f1bb17aa5",
    dishes: [
      {
        id: "64663e8dfe072f0461924091",
        restaurantID: "64663d1afe072f046192402b",
        dishID: "64663e8dfe072f0461924091",
        extras: [
          {
            text: "frites ",
            extras_price: 2,
            _id: "64695500fc1951272c99ccf6",
            selected: true,
          },
        ],
        name: "Poulet Merguez",
        quantity: 1,
        price: 15,
        dishPrice: 15,
        dishImageUrl:
          "https://res.cloudinary.com/dhsywr3il/image/upload/v1684624592/clickSo/dishes/blgdmcxggjw9uh4bh64k.jpg",
        deliveryFee: 0,
        serviceFee: 1.5,
      },
    ],
    restaurant_name: "AlyaNeila",
    user: "63e63f44275a619b2f809983",
    restaurantId: "64663d1afe072f046192402b",
    status: "completed",
    orderNumber: 1686801942017,
    total: 16.5,
    mode_of_payment: "google_pay",
    deliveryAddress: "10 Rue Edouard Vaillant, Nord",
    service_fee: 0,
    discount_amount: 15,
    reviews: [],
    avgRating: 0,
    reviewed: false,
    createdAt: "2023-05-29T10:55:04.899Z",
    updatedAt: "2023-05-29T11:07:06.266Z",
    __v: 0,
    invoice_url:
      "http://res.cloudinary.com/dhsywr3il/image/upload/v1685357710/invoices/yrdowlfeoanvkb4iwp42.pdf",
    id: "6474848881682b0f1bb17aa5",
  },
  {
    _id: "64695254fc1951272c99c7a4",
    dishes: [
      {
        id: "64663f06fe072f0461924153",
        restaurantID: "64663d1afe072f046192402b",
        dishID: "64663f06fe072f0461924153",
        extras: [
          {
            text: "frites ",
            extras_price: 2,
            _id: "64695170fc1951272c99c6c8",
            selected: true,
          },
        ],
        name: "Burger ",
        quantity: 1,
        price: 13,
        dishPrice: 13,
        dishImageUrl:
          "https://res.cloudinary.com/dhsywr3il/image/upload/v1684422405/clickSo/dishes/nfelgvryrzfox25gnjuo.jpg",
        deliveryFee: 0,
        serviceFee: 1.5,
      },
    ],
    restaurant_name: "AlyaNeila",
    user: "63e63f44275a619b2f809983",
    restaurantId: "64663d1afe072f046192402b",
    status: "cancelled",
    orderNumber: 1687289801081,
    total: 14.5,
    mode_of_payment: "google_pay",
    deliveryAddress: "1 Rue Edouard Vaillant, Nord",
    service_fee: 0,
    discount_amount: 13,
    createdAt: "2023-05-20T23:05:56.407Z",
    updatedAt: "2023-05-29T11:06:03.743Z",
    __v: 1,
    invoice_url:
      "http://res.cloudinary.com/dhsywr3il/image/upload/v1684623961/invoices/py3len6xvdnkkcn5hyle.pdf",
    username: "Soso1215",
    avgRating: 0,
    estimated_delivery_time: "23:40",
    reviewed: false,
    reviews: [],
    id: "64695254fc1951272c99c7a4",
  },
  {
    _id: "646951c1fc1951272c99c769",
    dishes: [
      {
        id: "64663f06fe072f0461924153",
        restaurantID: "64663d1afe072f046192402b",
        dishID: "64663f06fe072f0461924153",
        extras: [
          {
            text: "menu",
            extras_price: 5,
            _id: "64695170fc1951272c99c6c9",
            selected: true,
          },
        ],
        name: "Burger ",
        quantity: 1,
        price: 16,
        dishPrice: 16,
        dishImageUrl:
          "https://res.cloudinary.com/dhsywr3il/image/upload/v1684422405/clickSo/dishes/nfelgvryrzfox25gnjuo.jpg",
        deliveryFee: 0,
        serviceFee: 1.5,
      },
    ],
    restaurant_name: "AlyaNeila",
    user: "63e63f44275a619b2f809983",
    restaurantId: "64663d1afe072f046192402b",
    status: "cancelled",
    orderNumber: 1688642340487,
    total: 17.5,
    mode_of_payment: "google_pay",
    deliveryAddress: "3 Rue Edouard Vaillant, Nord",
    service_fee: 0,
    discount_amount: 16,
    createdAt: "2023-05-20T23:03:29.755Z",
    updatedAt: "2023-05-29T11:05:55.945Z",
    __v: 1,
    invoice_url:
      "http://res.cloudinary.com/dhsywr3il/image/upload/v1684623814/invoices/miw0khhrxudeue18i3mo.pdf",
    username: "Soso1215",
    avgRating: 0,
    estimated_delivery_time: "23:38",
    reviewed: false,
    reviews: [],
    id: "646951c1fc1951272c99c769",
  },
  {
    reviews: [],
    avgRating: 0,
    reviewed: false,
    _id: "6469497cfc1951272c99bd8e",
    dishes: [
      {
        id: "64663f06fe072f0461924153",
        restaurantID: "64663d1afe072f046192402b",
        dishID: "64663f06fe072f0461924153",
        extras: [],
        name: "Burger ",
        quantity: 1,
        price: 11,
        dishPrice: 11,
        dishImageUrl:
          "https://res.cloudinary.com/dhsywr3il/image/upload/v1684422405/clickSo/dishes/nfelgvryrzfox25gnjuo.jpg",
        deliveryFee: 0,
        serviceFee: 1.5,
      },
    ],
    restaurant_name: "AlyaNeila",
    user: "63e63f44275a619b2f809983",
    restaurantId: "64663d1afe072f046192402b",
    status: "completed",
    orderNumber: 1685188808731,
    total: 12.5,
    mode_of_payment: "google_pay",
    deliveryAddress: "1 Rue Edouard Vaillant, Nord",
    service_fee: 0,
    discount_amount: 11,
    createdAt: "2023-05-20T22:28:12.262Z",
    updatedAt: "2023-05-20T22:34:58.109Z",
    __v: 0,
    invoice_url:
      "http://res.cloudinary.com/dhsywr3il/image/upload/v1684621698/invoices/bwvr6iyafawj8k7qbq6e.pdf",
    estimated_delivery_time: "23:3",
    username: "Soso1215",
    id: "6469497cfc1951272c99bd8e",
  },
  {
    reviews: [],
    avgRating: 0,
    reviewed: false,
    _id: "6468a288fc1951272c99b8e1",
    dishes: [
      {
        id: "64663e8dfe072f0461924091",
        restaurantID: "64663d1afe072f046192402b",
        dishID: "64663e8dfe072f0461924091",
        extras: [
          {
            text: "frites ",
            extras_price: 2,
            _id: "64664289fe072f046192429a",
            selected: true,
          },
        ],
        name: "Poulet Merguez",
        quantity: 2,
        price: 28,
        dishPrice: 14,
        dishImageUrl:
          "https://res.cloudinary.com/dhsywr3il/image/upload/v1684422284/clickSo/dishes/hmnk2tkio7z99mglfmae.jpg",
        deliveryFee: 0,
        serviceFee: 1.5,
      },
    ],
    restaurant_name: "AlyaNeila",
    user: "63e63f44275a619b2f809983",
    restaurantId: "64663d1afe072f046192402b",
    status: "completed",
    orderNumber: 1688280776884,
    total: 29.5,
    mode_of_payment: "google_pay",
    deliveryAddress: "10 Rue Edouard Vaillant, Nord",
    service_fee: 0,
    discount_amount: 28,
    createdAt: "2023-05-20T10:35:52.825Z",
    updatedAt: "2023-05-20T12:10:33.518Z",
    __v: 0,
    invoice_url:
      "http://res.cloudinary.com/dhsywr3il/image/upload/v1684578959/invoices/sc9uf5tk3fgu0bkl2i99.pdf",
    estimated_delivery_time: "11:20",
    username: "Soso1215",
    id: "6468a288fc1951272c99b8e1",
  },
  {
    reviews: [],
    avgRating: 0,
    reviewed: false,
    _id: "646793bffc1951272c99b62d",
    dishes: [
      {
        id: "64663e8dfe072f0461924091",
        restaurantID: "64663d1afe072f046192402b",
        dishID: "64663e8dfe072f0461924091",
        extras: [
          {
            text: "frites ",
            extras_price: 2,
            _id: "64664289fe072f046192429a",
            selected: true,
          },
        ],
        name: "Poulet Merguez",
        quantity: 2,
        price: 28,
        dishPrice: 14,
        dishImageUrl:
          "https://res.cloudinary.com/dhsywr3il/image/upload/v1684422284/clickSo/dishes/hmnk2tkio7z99mglfmae.jpg",
        deliveryFee: 0,
        serviceFee: 1.5,
      },
    ],
    restaurant_name: "AlyaNeila",
    user: "63e63f44275a619b2f809983",
    restaurantId: "64663d1afe072f046192402b",
    status: "completed",
    orderNumber: 1689326264324,
    total: 29.5,
    mode_of_payment: "google_pay",
    deliveryAddress: "Parc du Lion, Nord",
    service_fee: 0,
    discount_amount: 28,
    createdAt: "2023-05-19T15:20:31.617Z",
    updatedAt: "2023-05-19T15:21:42.772Z",
    __v: 0,
    invoice_url:
      "http://res.cloudinary.com/dhsywr3il/image/upload/v1684509637/invoices/qvctguximflfd3wfbis0.pdf",
    username: "Soso1215",
    id: "646793bffc1951272c99b62d",
  },
  {
    reviews: [],
    avgRating: 0,
    reviewed: false,
    _id: "646783b7aefa8850aadb3176",
    dishes: [
      {
        id: "64663f06fe072f0461924153",
        restaurantID: "64663d1afe072f046192402b",
        dishID: "64663f06fe072f0461924153",
        extras: [
          {
            text: "menu",
            extras_price: 3,
            _id: "64663f06fe072f0461924154",
            selected: true,
          },
        ],
        name: "Burger ",
        quantity: 2,
        price: 25,
        dishPrice: 12.5,
        dishImageUrl:
          "https://res.cloudinary.com/dhsywr3il/image/upload/v1684422405/clickSo/dishes/nfelgvryrzfox25gnjuo.jpg",
        deliveryFee: 0,
        serviceFee: 1.5,
      },
    ],
    restaurant_name: "AlyaNeila",
    user: "63e63f44275a619b2f809983",
    restaurantId: "64663d1afe072f046192402b",
    status: "completed",
    orderNumber: 1689139830680,
    total: 26.5,
    mode_of_payment: "google_pay",
    deliveryAddress: "42 Bd de Lyon, Nord",
    service_fee: 0,
    discount_amount: 25,
    createdAt: "2023-05-19T14:12:07.550Z",
    updatedAt: "2023-05-19T14:13:56.552Z",
    __v: 0,
    invoice_url:
      "http://res.cloudinary.com/dhsywr3il/image/upload/v1684505532/invoices/w3glecbv1ymrar94iinu.pdf",
    estimated_delivery_time: "14:57",
    username: "Soso1215",
    id: "646783b7aefa8850aadb3176",
  },
  {
    reviews: [],
    avgRating: 0,
    reviewed: false,
    _id: "6467336dfe072f0461925470",
    dishes: [
      {
        id: "646666defe072f0461924d49",
        restaurantID: "6465ee02fe072f0461923e84",
        dishID: "646666defe072f0461924d49",
        extras: [],
        name: "bonne food",
        quantity: 1,
        price: 12,
        dishPrice: 12,
        dishImageUrl:
          "https://res.cloudinary.com/dhsywr3il/image/upload/v1684432605/clickSo/dishes/mwy1xtuu40ba0whfj9dj.jpg",
        deliveryFee: 0,
        serviceFee: 1.5,
      },
    ],
    restaurant_name: "Elhadj Resto",
    user: "63e63f44275a619b2f809983",
    restaurantId: "6465ee02fe072f0461923e84",
    status: "ordered",
    orderNumber: 1686589804767,
    total: 13.5,
    mode_of_payment: "google_pay",
    deliveryAddress: "10 Rue Edouard Vaillant, Nord",
    service_fee: 0,
    discount_amount: 12,
    createdAt: "2023-05-19T08:29:33.165Z",
    updatedAt: "2023-05-19T08:29:38.580Z",
    __v: 0,
    invoice_url:
      "http://res.cloudinary.com/dhsywr3il/image/upload/v1684484978/invoices/kig1q7v5b0gm43tp88d4.pdf",
    username: "Soso1215",
    id: "6467336dfe072f0461925470",
  },
  {
    reviews: [],
    avgRating: 0,
    reviewed: false,
    _id: "64667797fe072f0461925277",
    dishes: [
      {
        id: "6466739efe072f0461925189",
        restaurantID: "6466715bfe072f0461925076",
        dishID: "6466739efe072f0461925189",
        extras: [],
        name: "poulet",
        quantity: 2,
        price: 40,
        dishPrice: 20,
        dishImageUrl:
          "https://res.cloudinary.com/dhsywr3il/image/upload/v1684435869/clickSo/dishes/i9xars969nkoxpczqkbn.jpg",
        deliveryFee: 0,
        serviceFee: 1.5,
      },
    ],
    restaurant_name: "ChezPaul",
    user: "63e63f44275a619b2f809983",
    restaurantId: "6466715bfe072f0461925076",
    status: "ordered",
    orderNumber: 1687574497410,
    total: 41.5,
    mode_of_payment: "google_pay",
    deliveryAddress: "162 Rue d'Inkermann, Nord",
    service_fee: 0,
    discount_amount: 40,
    createdAt: "2023-05-18T19:08:07.790Z",
    updatedAt: "2023-05-18T19:08:13.042Z",
    __v: 0,
    invoice_url:
      "http://res.cloudinary.com/dhsywr3il/image/upload/v1684436892/invoices/zoksqphuw9kwxpiigopl.pdf",
    username: "Soso1215",
    id: "64667797fe072f0461925277",
  },
  {
    _id: "64666b94e8c9d8a09e64da69",
    dishes: [
      {
        id: "64665cfbfe072f04619248a3",
        restaurantID: "64665a4dfe072f0461924455",
        dishID: "64665cfbfe072f04619248a3",
        extras: [
          {
            text: "Water",
            extras_price: 4,
            _id: "64665cfbfe072f04619248a6",
            selected: true,
          },
          {
            text: "Fanta",
            extras_price: 5,
            _id: "64665cfbfe072f04619248a5",
            selected: true,
          },
        ],
        name: "Chicken Wings",
        quantity: 1,
        price: 22.5,
        dishPrice: 22.5,
        dishImageUrl:
          "https://res.cloudinary.com/dhsywr3il/image/upload/v1684430075/clickSo/dishes/nlnnxhx4pqh74voyeq2g.jpg",
        deliveryFee: 0,
        serviceFee: 1.5,
      },
    ],
    restaurant_name: "Jolinda Foods",
    user: "63ea4c4578ddb893b2252ffc",
    restaurantId: "64665a4dfe072f0461924455",
    status: "ordered",
    orderNumber: 1685281182405,
    total: 24,
    mode_of_payment: "google_pay",
    deliveryAddress: "1600 Amphitheatre Pkwy, Santa Clara County",
    service_fee: 0,
    discount_amount: 20.25,
    createdAt: "2023-05-18T18:16:52.815Z",
    updatedAt: "2023-05-28T21:56:49.725Z",
    __v: 1,
    invoice_url:
      "http://res.cloudinary.com/dhsywr3il/image/upload/v1684433870/invoices/omrzrzfffvplkunsygnp.pdf",
    username: "Daniel",
    avgRating: 0,
    estimated_delivery_time: "19:1",
    reviewed: false,
    reviews: [],
    id: "64666b94e8c9d8a09e64da69",
  },
];

export const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const workingDaysSchedule = [
  {
    day: "Lundi",
    hours: ["closed"],
  },
  {
    day: "Mardi",
    hours: ["closed"],
  },
  {
    day: "Mercredi",
    hours: ["closed"],
  },
  {
    day: "Jeudi",
    hours: ["closed"],
  },
  {
    day: "Vendredi",
    hours: ["closed"],
  },
  {
    day: "Samedi",
    hours: ["closed"],
  },
  {
    day: "Dimanche",
    hours: ["closed"],
  },
];

export const categories = [
  { id: 1, title: "Combos", image: Combo2 },
  { id: 2, title: "Fries", image: Fries },
  { id: 3, title: "Pizza", image: Pizza },
  { id: 4, title: "Burger", image: Burger },
  { id: 5, title: "Chicken", image: Chicken },
  { id: 6, title: "Sauces", image: Combos },
  { id: 7, title: "Drinks", image: Drinks },
  // { id: 8, title: "All", image: Combos },
];

// RESTAURANTS PAGE

export const checkBoxLabels = [
  "Lundi",
  "Mardi",
  "Mercredi",
  "Jeudi",
  "Vendredi",
  "Samedi",
  "Dimanche",
];

export const deliveryOptions = ["Delivery", "Pick Up"];

export const extraFiltersOption = [...deliveryOptions, "En Promo"];

export const labels = {
  0.5: "Useless",
  1: "Useless+",
  1.5: "Poor",
  2: "Poor+",
  2.5: "Ok",
  3: "Ok+",
  3.5: "Good",
  4: "Good+",
  4.5: "Excellent",
  5: "Excellent+",
};

export const countryPhoneCodes = [
  { country: "Afghanistan", code: "93", iso: "AF" },
  { country: "Albania", code: "355", iso: "AL" },
  { country: "Algeria", code: "213", iso: "DZ" },
  { country: "American Samoa", code: "1-684", iso: "AS" },
  { country: "Andorra", code: "376", iso: "AD" },
  { country: "Angola", code: "244", iso: "AO" },
  { country: "Anguilla", code: "1-264", iso: "AI" },
  { country: "Antarctica", code: "672", iso: "AQ" },
  { country: "Antigua and Barbuda", code: "1-268", iso: "AG" },
  { country: "Argentina", code: "54", iso: "AR" },
  { country: "Armenia", code: "374", iso: "AM" },
  { country: "Aruba", code: "297", iso: "AW" },
  { country: "Australia", code: "61", iso: "AU" },
  { country: "Austria", code: "43", iso: "AT" },
  { country: "Azerbaijan", code: "994", iso: "AZ" },
  { country: "Bahamas", code: "1-242", iso: "BS" },
  { country: "Bahrain", code: "973", iso: "BH" },
  { country: "Bangladesh", code: "880", iso: "BD" },
  { country: "Barbados", code: "1-246", iso: "BB" },
  { country: "Belarus", code: "375", iso: "BY" },
  { country: "Belgium", code: "32", iso: "BE" },
  { country: "Belize", code: "501", iso: "BZ" },
  { country: "Benin", code: "229", iso: "BJ" },
  { country: "Bermuda", code: "1-441", iso: "BM" },
  { country: "Bhutan", code: "975", iso: "BT" },
  { country: "Bolivia", code: "591", iso: "BO" },
  { country: "Bosnia and Herzegovina", code: "387", iso: "BA" },
  { country: "Botswana", code: "267", iso: "BW" },
  { country: "Brazil", code: "55", iso: "BR" },
  { country: "British Indian Ocean Territory", code: "246", iso: "IO" },
  { country: "British Virgin Islands", code: "1-284", iso: "VG" },
  { country: "Brunei", code: "673", iso: "BN" },
  { country: "Bulgaria", code: "359", iso: "BG" },
  { country: "Burkina Faso", code: "226", iso: "BF" },
  { country: "Burundi", code: "257", iso: "BI" },
  { country: "Cambodia", code: "855", iso: "KH" },
  { country: "Cameroon", code: "237", iso: "CM" },
  { country: "Canada", code: "1", iso: "CA" },
  { country: "Cape Verde", code: "238", iso: "CV" },
  { country: "Cayman Islands", code: "1-345", iso: "KY" },
  { country: "Central African Republic", code: "236", iso: "CF" },
  { country: "Chad", code: "235", iso: "TD" },
  { country: "Chile", code: "56", iso: "CL" },
  { country: "China", code: "86", iso: "CN" },
  { country: "Christmas Island", code: "61", iso: "CX" },
  { country: "Cocos Islands", code: "61", iso: "CC" },
  { country: "Colombia", code: "57", iso: "CO" },
  { country: "Comoros", code: "269", iso: "KM" },
  { country: "Cook Islands", code: "682", iso: "CK" },
  { country: "Costa Rica", code: "506", iso: "CR" },
  { country: "Croatia", code: "385", iso: "HR" },
  { country: "Cuba", code: "53", iso: "CU" },
  { country: "Curacao", code: "599", iso: "CW" },
  { country: "Cyprus", code: "357", iso: "CY" },
  { country: "Czech Republic", code: "420", iso: "CZ" },
  { country: "Democratic Republic of the Congo", code: "243", iso: "CD" },
  { country: "Denmark", code: "45", iso: "DK" },
  { country: "Djibouti", code: "253", iso: "DJ" },
  { country: "Dominica", code: "1-767", iso: "DM" },
  { country: "Dominican Republic", code: "1-809, 1-829, 1-849", iso: "DO" },
  { country: "East Timor", code: "670", iso: "TL" },
  { country: "Ecuador", code: "593", iso: "EC" },
  { country: "Egypt", code: "20", iso: "EG" },
  { country: "El Salvador", code: "503", iso: "SV" },
  { country: "Equatorial Guinea", code: "240", iso: "GQ" },
  { country: "Eritrea", code: "291", iso: "ER" },
  { country: "Estonia", code: "372", iso: "EE" },
  { country: "Ethiopia", code: "251", iso: "ET" },
  { country: "Falkland Islands", code: "500", iso: "FK" },
  { country: "Faroe Islands", code: "298", iso: "FO" },
  { country: "Fiji", code: "679", iso: "FJ" },
  { country: "Finland", code: "358", iso: "FI" },
  { country: "France", code: "33", iso: "FR" },
  { country: "French Polynesia", code: "689", iso: "PF" },
  { country: "Gabon", code: "241", iso: "GA" },
  { country: "Gambia", code: "220", iso: "GM" },
  { country: "Georgia", code: "995", iso: "GE" },
  { country: "Germany", code: "49", iso: "DE" },
  { country: "Ghana", code: "233", iso: "GH" },
  { country: "Gibraltar", code: "350", iso: "GI" },
  { country: "Greece", code: "30", iso: "GR" },
  { country: "Greenland", code: "299", iso: "GL" },
  { country: "Grenada", code: "1-473", iso: "GD" },
  { country: "Guam", code: "1-671", iso: "GU" },
  { country: "Guatemala", code: "502", iso: "GT" },
  { country: "Guernsey", code: "44-1481", iso: "GG" },
  { country: "Guinea", code: "224", iso: "GN" },
  { country: "Guinea-Bissau", code: "245", iso: "GW" },
  { country: "Guyana", code: "592", iso: "GY" },
  { country: "Haiti", code: "509", iso: "HT" },
  { country: "Honduras", code: "504", iso: "HN" },
  { country: "Hong Kong", code: "852", iso: "HK" },
  { country: "Hungary", code: "36", iso: "HU" },
  { country: "Iceland", code: "354", iso: "IS" },
  { country: "India", code: "91", iso: "IN" },
  { country: "Indonesia", code: "62", iso: "ID" },
  { country: "Iran", code: "98", iso: "IR" },
  { country: "Iraq", code: "964", iso: "IQ" },
  { country: "Ireland", code: "353", iso: "IE" },
  { country: "Isle of Man", code: "44-1624", iso: "IM" },
  { country: "Israel", code: "972", iso: "IL" },
  { country: "Italy", code: "39", iso: "IT" },
  { country: "Ivory Coast", code: "225", iso: "CI" },
  { country: "Jamaica", code: "1-876", iso: "JM" },
  { country: "Japan", code: "81", iso: "JP" },
  { country: "Jersey", code: "44-1534", iso: "JE" },
  { country: "Jordan", code: "962", iso: "JO" },
  { country: "Kazakhstan", code: "7", iso: "KZ" },
  { country: "Kenya", code: "254", iso: "KE" },
  { country: "Kiribati", code: "686", iso: "KI" },
  { country: "Kosovo", code: "383", iso: "XK" },
  { country: "Kuwait", code: "965", iso: "KW" },
  { country: "Kyrgyzstan", code: "996", iso: "KG" },
  { country: "Laos", code: "856", iso: "LA" },
  { country: "Latvia", code: "371", iso: "LV" },
  { country: "Lebanon", code: "961", iso: "LB" },
  { country: "Lesotho", code: "266", iso: "LS" },
  { country: "Liberia", code: "231", iso: "LR" },
  { country: "Libya", code: "218", iso: "LY" },
  { country: "Liechtenstein", code: "423", iso: "LI" },
  { country: "Lithuania", code: "370", iso: "LT" },
  { country: "Luxembourg", code: "352", iso: "LU" },
  { country: "Macao", code: "853", iso: "MO" },
  { country: "Macedonia", code: "389", iso: "MK" },
  { country: "Madagascar", code: "261", iso: "MG" },
  { country: "Malawi", code: "265", iso: "MW" },
  { country: "Malaysia", code: "60", iso: "MY" },
  { country: "Maldives", code: "960", iso: "MV" },
  { country: "Mali", code: "223", iso: "ML" },
  { country: "Malta", code: "356", iso: "MT" },
  { country: "Marshall Islands", code: "692", iso: "MH" },
  { country: "Mauritania", code: "222", iso: "MR" },
  { country: "Mauritius", code: "230", iso: "MU" },
  { country: "Mayotte", code: "262", iso: "YT" },
  { country: "Mexico", code: "52", iso: "MX" },
  { country: "Micronesia", code: "691", iso: "FM" },
  { country: "Moldova", code: "373", iso: "MD" },
  { country: "Monaco", code: "377", iso: "MC" },
  { country: "Mongolia", code: "976", iso: "MN" },
  { country: "Montenegro", code: "382", iso: "ME" },
  { country: "Montserrat", code: "1-664", iso: "MS" },
  { country: "Morocco", code: "212", iso: "MA" },
  { country: "Mozambique", code: "258", iso: "MZ" },
  { country: "Myanmar", code: "95", iso: "MM" },
  { country: "Namibia", code: "264", iso: "NA" },
  { country: "Nauru", code: "674", iso: "NR" },
  { country: "Nepal", code: "977", iso: "NP" },
  { country: "Netherlands", code: "31", iso: "NL" },
  { country: "Netherlands Antilles", code: "599", iso: "AN" },
  { country: "New Caledonia", code: "687", iso: "NC" },
  { country: "New Zealand", code: "64", iso: "NZ" },
  { country: "Nicaragua", code: "505", iso: "NI" },
  { country: "Niger", code: "227", iso: "NE" },
  { country: "Nigeria", code: "234", iso: "NG" },
  { country: "Niue", code: "683", iso: "NU" },
  { country: "North Korea", code: "850", iso: "KP" },
  { country: "Northern Mariana Islands", code: "1-670", iso: "MP" },
  { country: "Norway", code: "47", iso: "NO" },
  { country: "Oman", code: "968", iso: "OM" },
  { country: "Pakistan", code: "92", iso: "PK" },
  { country: "Palau", code: "680", iso: "PW" },
  { country: "Palestine", code: "970", iso: "PS" },
  { country: "Panama", code: "507", iso: "PA" },
  { country: "Papua New Guinea", code: "675", iso: "PG" },
  { country: "Paraguay", code: "595", iso: "PY" },
  { country: "Peru", code: "51", iso: "PE" },
  { country: "Philippines", code: "63", iso: "PH" },
  { country: "Pitcairn", code: "64", iso: "PN" },
  { country: "Poland", code: "48", iso: "PL" },
  { country: "Portugal", code: "351", iso: "PT" },
  { country: "Puerto Rico", code: "1-787, 1-939", iso: "PR" },
  { country: "Qatar", code: "974", iso: "QA" },
  { country: "Republic of the Congo", code: "242", iso: "CG" },
  { country: "Reunion", code: "262", iso: "RE" },
  { country: "Romania", code: "40", iso: "RO" },
  { country: "Russia", code: "7", iso: "RU" },
  { country: "Rwanda", code: "250", iso: "RW" },
  { country: "Saint Barthelemy", code: "590", iso: "BL" },
  { country: "Saint Helena", code: "290", iso: "SH" },
  { country: "Saint Kitts and Nevis", code: "1-869", iso: "KN" },
  { country: "Saint Lucia", code: "1-758", iso: "LC" },
  { country: "Saint Martin", code: "590", iso: "MF" },
  { country: "Saint Pierre and Miquelon", code: "508", iso: "PM" },
  { country: "Saint Vincent and the Grenadines", code: "1-784", iso: "VC" },
  { country: "Samoa", code: "685", iso: "WS" },
  { country: "San Marino", code: "378", iso: "SM" },
  { country: "Sao Tome and Principe", code: "239", iso: "ST" },
  { country: "Saudi Arabia", code: "966", iso: "SA" },
  { country: "Senegal", code: "221", iso: "SN" },
  { country: "Serbia", code: "381", iso: "RS" },
  { country: "Seychelles", code: "248", iso: "SC" },
  { country: "Sierra Leone", code: "232", iso: "SL" },
  { country: "Singapore", code: "65", iso: "SG" },
  { country: "Sint Maarten", code: "1-721", iso: "SX" },
  { country: "Slovakia", code: "421", iso: "SK" },
  { country: "Slovenia", code: "386", iso: "SI" },
  { country: "Solomon Islands", code: "677", iso: "SB" },
  { country: "Somalia", code: "252", iso: "SO" },
  { country: "South Africa", code: "27", iso: "ZA" },
  { country: "South Korea", code: "82", iso: "KR" },
  { country: "South Sudan", code: "211", iso: "SS" },
  { country: "Spain", code: "34", iso: "ES" },
  { country: "Sri Lanka", code: "94", iso: "LK" },
  { country: "Sudan", code: "249", iso: "SD" },
  { country: "Suriname", code: "597", iso: "SR" },
  { country: "Svalbard and Jan Mayen", code: "47", iso: "SJ" },
  { country: "Swaziland", code: "268", iso: "SZ" },
  { country: "Sweden", code: "46", iso: "SE" },
  { country: "Switzerland", code: "41", iso: "CH" },
  { country: "Syria", code: "963", iso: "SY" },
  { country: "Taiwan", code: "886", iso: "TW" },
  { country: "Tajikistan", code: "992", iso: "TJ" },
  { country: "Tanzania", code: "255", iso: "TZ" },
  { country: "Thailand", code: "66", iso: "TH" },
  { country: "Togo", code: "228", iso: "TG" },
  { country: "Tokelau", code: "690", iso: "TK" },
  { country: "Tonga", code: "676", iso: "TO" },
  { country: "Trinidad and Tobago", code: "1-868", iso: "TT" },
  { country: "Tunisia", code: "216", iso: "TN" },
  { country: "Turkey", code: "90", iso: "TR" },
  { country: "Turkmenistan", code: "993", iso: "TM" },
  { country: "Turks and Caicos Islands", code: "1-649", iso: "TC" },
  { country: "Tuvalu", code: "688", iso: "TV" },
  { country: "U.S. Virgin Islands", code: "1-340", iso: "VI" },
  { country: "Uganda", code: "256", iso: "UG" },
  { country: "Ukraine", code: "380", iso: "UA" },
  { country: "United Arab Emirates", code: "971", iso: "AE" },
  { country: "United Kingdom", code: "44", iso: "GB" },
  { country: "United States", code: "1", iso: "US" },
  { country: "Uruguay", code: "598", iso: "UY" },
  { country: "Uzbekistan", code: "998", iso: "UZ" },
  { country: "Vanuatu", code: "678", iso: "VU" },
  { country: "Vatican", code: "379", iso: "VA" },
  { country: "Venezuela", code: "58", iso: "VE" },
  { country: "Vietnam", code: "84", iso: "VN" },
  { country: "Wallis and Futuna", code: "681", iso: "WF" },
  { country: "Western Sahara", code: "212", iso: "EH" },
  { country: "Yemen", code: "967", iso: "YE" },
  { country: "Zambia", code: "260", iso: "ZM" },
  { country: "Zimbabwe", code: "263", iso: "ZW" },
];
